import { useInfiniteQuery } from '@tanstack/react-query';

import { TABLE_ITEMS_PER_PAGE } from 'src/constants';
import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import { GetInvitationsResponse } from 'src/types/rest/managementPortalApi';

interface UseSearchInvitationProps {
  searchQuery?: string;
}

export const useInvitations = ({ searchQuery }: UseSearchInvitationProps) => {
  const {
    managementPortalApi: { apiHost },
  } = useAppConfig();

  return useInfiniteQuery({
    getNextPageParam: (lastPage: GetInvitationsResponse) =>
      lastPage.nextCursor ?? undefined,
    initialPageParam: undefined as string | undefined,
    // TODO: switch to TanStack Virtual if performance becomes an issue due to high volume of invitations.
    queryFn: ({ pageParam }) =>
      apiRequest<GetInvitationsResponse>({
        url: `${apiHost}/invitations?limit=${TABLE_ITEMS_PER_PAGE}${searchQuery ? `&search=${searchQuery}` : ''}${pageParam ? `&cursor=${pageParam}` : ''}`,
      }),
    queryKey: ['invitations', searchQuery],
  });
};
